<script setup lang="ts">
import Logo from '@/assets/logo.svg?component'
import LogoMobile from '@/assets/logo_mobile.svg?component'

const store = useStore()
const cartStore = useCartStore()

useLazyAsyncData('cart', () => cartStore.init(), {
  server: false
})

const { searchBarIsFocused } = storeToRefs(store)
const { isEmpty, roundedProductsQuantity } = storeToRefs(cartStore)
const { status } = useAuth()

const loginLink = computed(() => status.value === 'authenticated'
  ? { text: 'Moje konto', link: '/u/moje-konto' }
  : { text: 'Zaloguj się', link: '/u/logowanie' }
)
</script>

<template>
  <HeaderTopBar />
  <MenuMobile class="block lg:hidden" />
  <div class="container py-[10px] lg:mx-auto lg:flex lg:justify-between lg:items-center">
    <div class="flex lg:flex-col justify-between gap-3 relative h-11">
      <NuxtLink to="/" title="Go-Racing.pl" class="flex items-center" :class="{'hidden':searchBarIsFocused}">
        <LogoMobile class="block lg:hidden" />
        <Logo class="hidden lg:block" />
      </NuxtLink>
      <div class="lg:hidden w-full relative">
        <MenuSearch :mobile="true" />
      </div>
    </div>
    <div class="hidden lg:flex justify-end gap-4 xl:gap-[30px] relative z-40">
      <MenuSearch :mobile="false" />
      <NuxtLink to="/rezerwacja" class="flex flex-col items-center text-gray-400">
        <i class="icon-calendar text-[20px]" />
        <span class="text-12">Zarezerwuj</span>
      </NuxtLink>
      <NuxtLink :to="loginLink.link" class="flex flex-col items-center text-gray-400">
        <i class="icon-zaloguj-sie text-[20px]" />
        <span class="text-12">{{ loginLink.text }}</span>
      </NuxtLink>
    </div>
  </div>
  <div class="hidden container py-[10px] lg:mx-auto lg:flex lg:justify-between lg:items-center">
    <MenuDesktop />
    <NuxtLink
      :class="[
        'flex items-center text-gray-400 px-3 py-2 relative rounded-[8px] border border-primary transition-colors duration-150 ease-in',
        { 'bg-primary text-white': !isEmpty }
      ]"
      to="/koszyk"
    >
      <i :class="['icon-shop text-18 ', { '!text-red': isEmpty }]" />
      <span :class="['mx-2 text-14 ', { '!text-red': isEmpty }]">Koszyk</span>
      <Transition enter-active-class="animate-zoom-in" leave-active-class="animate-zoom-out">
        <Badge v-if="!isEmpty" class="relative bg-primary text-white">
          {{ roundedProductsQuantity }}
        </Badge>
      </Transition>
    </NuxtLink>
  </div>
</template>
